import { FC } from 'react';

import { useAppSelector } from '@/shared/hooks';

import { MPRModel } from '@/features/MPR';

import { FullHeadMPRPanel } from '../FullHeadMPRPanel';

type ToothFullHeadMPRPanelProps = {
  patientID: string;
  reportID: string;
  toothID: string;
  className?: string;
};

export const ToothFullHeadMPRPanel: FC<ToothFullHeadMPRPanelProps> = (
  props,
) => {
  const { patientID, reportID, toothID, className } = props;

  const volumeState = useAppSelector(
    MPRModel.selectors.selectDCCTVolumeState({ patientID, reportID }),
  );

  return (
    <FullHeadMPRPanel
      variant="tooth"
      volumeState={volumeState}
      className={className}
      toothID={toothID}
    />
  );
};
